import { alpha, createTheme } from '@mui/material/styles'
import { brand } from './brand'

/** Roboto: font duy nhất cho cả tiêu đề và nội dung (nạp qua Google Fonts trong index.html, hỗ trợ tiếng Việt) */
export const fontBody = '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif'
export const fontHeading = fontBody

export const appTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brand.navy,
      light: '#3d7ab8',
      dark: '#0e3a66',
      contrastText: '#ffffff',
    },
    secondary: {
      main: brand.hotPink,
      light: '#ff85b3',
      dark: '#c91f65',
      contrastText: '#ffffff',
    },
    background: {
      default: brand.lightPink,
      paper: '#ffffff',
    },
    text: {
      primary: '#14233d',
      secondary: '#4a5568',
    },
    divider: alpha(brand.navy, 0.12),
  },
  typography: {
    fontFamily: fontBody,
    h1: { fontFamily: fontHeading, fontWeight: 700 },
    h2: { fontFamily: fontHeading, fontWeight: 700 },
    h3: { fontFamily: fontHeading, fontWeight: 700 },
    h4: { fontFamily: fontHeading, fontWeight: 700 },
    h5: { fontFamily: fontHeading, fontWeight: 600 },
    h6: { fontFamily: fontHeading, fontWeight: 600 },
    subtitle1: { fontFamily: fontHeading, fontWeight: 600 },
    subtitle2: { fontFamily: fontHeading, fontWeight: 600 },
    button: { fontFamily: fontBody, fontWeight: 600, letterSpacing: 0.02 },
    caption: { fontFamily: fontBody },
    overline: { fontFamily: fontBody, letterSpacing: 1.2 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: brand.lightPink,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
          fontWeight: 600,
        },
        containedPrimary: {
          boxShadow: `0 4px 14px ${alpha(brand.navy, 0.28)}`,
          '&:hover': {
            boxShadow: `0 6px 20px ${alpha(brand.navy, 0.36)}`,
          },
        },
        containedSecondary: {
          boxShadow: `0 4px 14px ${alpha(brand.hotPink, 0.35)}`,
          '&:hover': {
            boxShadow: `0 6px 20px ${alpha(brand.hotPink, 0.45)}`,
          },
        },
        outlinedSecondary: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: alpha(brand.hotPink, 0.06),
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: `0 8px 32px ${alpha(brand.navy, 0.08)}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: brand.hotPink,
          fontWeight: 500,
          '&:hover': {
            color: brand.accentPink,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: alpha(brand.navy, 0.06),
          fontWeight: 700,
          fontSize: '0.8125rem',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          color: brand.navy,
          borderBottom: `2px solid ${alpha(brand.hotPink, 0.45)}`,
        },
      },
    },
    MuiAlert: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          alignItems: 'flex-start',
          borderRadius: 16,
          borderWidth: 1.5,
          boxShadow: `0 10px 28px ${alpha(brand.navy, 0.08)}`,
          paddingTop: 10,
          paddingBottom: 10,
          '& .MuiAlert-icon': {
            paddingTop: 2,
            opacity: 0.98,
          },
          '& .MuiAlert-message': {
            width: '100%',
          },
          '& .MuiAlert-action': {
            alignItems: 'flex-start',
            paddingTop: 0,
          },
        },
        outlinedInfo: {
          backgroundColor: alpha('#1e88e5', 0.05),
          borderColor: alpha('#1e88e5', 0.24),
        },
        outlinedSuccess: {
          backgroundColor: alpha('#2e7d32', 0.05),
          borderColor: alpha('#2e7d32', 0.24),
        },
        outlinedWarning: {
          backgroundColor: alpha('#ed6c02', 0.06),
          borderColor: alpha('#ed6c02', 0.24),
        },
        outlinedError: {
          backgroundColor: alpha('#d32f2f', 0.05),
          borderColor: alpha('#d32f2f', 0.24),
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderRadius: 3,
          backgroundColor: brand.hotPink,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: fontHeading,
          fontWeight: 700,
          color: brand.navy,
          borderBottom: `1px solid ${alpha(brand.navy, 0.08)}`,
          paddingBottom: 16,
        },
      },
    },
  },
})
